import { COMMON_DOMAIN_EMAILS, SEARCH_FORM_URL } from '@/common/constants/constants';
import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import styles from '@/styles/Home.module.css';
import { Button, Typography } from '@eventbrite/marmalade';
import Link from 'next/link';
import React from 'react';
import { PageTitle } from '../PageTitle';
import AccountFoundPageStyles from './AccountFound.module.scss';

interface AccountFoundPageProps {
  emailId: string;
}

export const AccountFound: React.FC<AccountFoundPageProps> = ({ emailId }) => {
  const LOGIN_URL = useEventbriteUrl('LOGIN_URL');
  const handleLoginClick = () => {
    window.open(LOGIN_URL, '_blank', 'noopener,noreferrer');
  };

  const handleTakeMeToEmailClick = () => {
    const [, emailDomain] = emailId.split('@');
    window.open(COMMON_DOMAIN_EMAILS[emailDomain], '_blank');
  };

  return (
    <>
      <PageTitle pageTitle={'Account found'} />
      <main className={styles.leftPaneContent}>
        <Typography variant="body-md" className={AccountFoundPageStyles.accountFoundContent}>
          We sent your login link to <strong>{emailId}</strong>. For your security, this link
          expires in 15 minutes.
        </Typography>

        <Button
          variant="primary"
          className={AccountFoundPageStyles.emailButton}
          onClick={handleTakeMeToEmailClick}
          data-heap-id="take_me_to_email"
        >
          Take me to my email
        </Button>
        <Button
          variant="secondary"
          className={AccountFoundPageStyles.loginButton}
          onClick={handleLoginClick}
          data-heap-id="account_found_go_to_login"
        >
          Use a password instead
        </Button>
        <div className={AccountFoundPageStyles.ticketLookupLink}>
          <Link href={SEARCH_FORM_URL}>
            <Typography
              variant="body-md-bold"
              className={AccountFoundPageStyles.ticketLookupLinkColor}
              data-heap-id="account_found_look_up_another_way"
            >
              Look up tickets another way
            </Typography>
          </Link>
        </div>
      </main>
    </>
  );
};
